import React from "react";

const ContextsLoader = () => {
    return (
        <div className="main_geo_loader_container">

            <div className="contexts_loader_cont">
                {Array.from({ length: 5 }).map((_, index) => (
                    <div className="contexts_loader_item fade-in" key={index}></div>
                ))}
            </div>
            <div className="text_btn_loader_cont">
                <div className="text_loader_cont">
                    <div className="text_loader_bottom fade-in"></div>
                </div>
                <div className="btn_loader_cont">
                    <div className="btn_loader fade-in"></div>
                </div>
            </div>
        </div>
    )
}

export default ContextsLoader